import { render } from "./TicketsHandleWaiting.vue?vue&type=template&id=0cd3301e&scoped=true&ts=true"
import script from "./TicketsHandleWaiting.vue?vue&type=script&lang=ts"
export * from "./TicketsHandleWaiting.vue?vue&type=script&lang=ts"

import "./TicketsHandleWaiting.vue?vue&type=style&index=0&id=0cd3301e&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd3301e"]])

export default __exports__